import ErrorCodes from './errorCodes';

const ErrorMessages = {
  [ErrorCodes.S_ALREADY_OPEN_SESSION]: 'csc.error.already_open_session',
  [ErrorCodes.S_NO_AGENT_ONLINE]: 'csc.error.no_agent_online',
  [ErrorCodes.S_EXCEED_QUEUE_LENGTH]: 'csc.error.exceed_queue',
  [ErrorCodes.S_SEND_MESSAGE_ERROR]: 'csc.error.send_message_error',

  [ErrorCodes.OUT_WORKING_TIME]: 'csc.error.out_working_time',
  [ErrorCodes.LOGIN_FAILED]: 'csc.error.api_login_failed',
  [ErrorCodes.DISPATCH_FAILED]: 'csc.error.dispatch_failed',
  [ErrorCodes.NOT_CONNECTED]: 'csc.error.not_connected',
  [ErrorCodes.NO_CONNECTION]: 'csc.error.no_connection',

  [ErrorCodes.SEND_MESSAGE_FAILED]: 'csc.error.send_message_error',
  [ErrorCodes.UPLOAD_FAILED]: 'csc.error.upload_failed',
  [ErrorCodes.SENT_IMAGE_FAILED]: 'csc.error.sent_image_failed',
  [ErrorCodes.SENT_FILE_FAILED]: 'csc.error.sent_file_failed',
  [ErrorCodes.EXCEED_FILE_SIZE]: 'csc.error.exceed_file_size',
  [ErrorCodes.INVALID_IMAGE_FILE]: 'csc.error.invalid_image_file',
  [ErrorCodes.INVALID_DOC_FILE]: 'csc.error.invalid_doc_file',

  [ErrorCodes.UNKNOWN_ERROR]: 'csc.error.unknown_error',

  [ErrorCodes.NO_PERMISSION]: 'csc.error.no_device_permission',
};

export default ErrorMessages;



// WEBPACK FOOTER //
// ./src/app/const/errorMessages.js